// extracted by mini-css-extract-plugin
export default {"container":"ReferralPill_container__Fylm-","icon":"ReferralPill_icon__2MA7H","title":"ReferralPill_title__fdxV6","body":"ReferralPill_body__Vr9ia"};